"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ProductsFieldsValueDetails = _interopRequireDefault(require("./components/ProductsFieldsValueDetails.vue"));
let default_1 = class extends _vuePropertyDecorator.Vue {};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ManageAttributeValue',
  components: {
    ProductsFieldValueDetail: _ProductsFieldsValueDetails.default
  },
  props: ['isEdit']
})], default_1);
var _default = exports.default = default_1;